import OnvoBase from "../base.js";
import { DataSource } from "../types/index.js";

export class OnvoDatasource extends OnvoBase {
  #id: string;

  constructor(id: string, apiKey: string, options?: { endpoint: string }) {
    super(apiKey, options);
    this.#id = id;
  }

  /**
   * Initializes the data source.
   * @returns {Promise<DataSource>} A promise that resolves to the data source object.
   */
  initialize(): Promise<DataSource> {
    return this.fetchBase(
      "/api/datasources/" + this.#id + "/initialize"
    ) as Promise<DataSource>;
  }

  /**
   * Uploads a file to the data source.
   * @param {File} file - The file to upload.
   * @returns {Promise<DataSource>} A promise that resolves to the data source object.
   */
  uploadFile(file: File): Promise<DataSource> {
    const formData = new FormData();
    formData.set("file", file);
    return this.fetchBase(
      "/api/datasources/" + this.#id + "/upload-file",
      "POST",
      formData,
      true
    ) as Promise<DataSource>;
  }

  /**
   * Retrieves the sample data from the data source.
   * @returns {Promise<any[]>} A promise that resolves to an array of sample data.
   */
  sample(): Promise<any[]> {
    return this.fetchBase(
      "/api/datasources/" + this.#id + "/sample"
    ) as Promise<any[]>;
  }
}
